import React, { useState } from 'react';
import axios from 'axios';
import Popup from 'reactjs-popup';
import { useNavigate } from 'react-router-dom';

const ModalAltaFidModifyPdv = ({ isVisible, onClose, choosenPdv, token }) => {
    const navigate = useNavigate();

    const [values, setValues] = useState({
        id_pdv:'',
        nom:'',
        adresse:'',
        email: ''
    })

    const handleClose = (e) => {  if(e.target.id === "wrapper") onClose(); }
    
    if (choosenPdv.id_pdv !== values.id_pdv) setValues({ ...values, ...choosenPdv })

    
    const deleteClient = (e) => {
        e.preventDefault();

        axios.delete(`${process.env.REACT_APP_IP_FID}:${process.env.REACT_APP_PORT_FID}/pdvs/deletePdv/${values.id_pdv}`,  {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .then((res) => {
                window.location.reload(false);
            }).catch(err => console.log(err))
        
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        axios.put(`${process.env.REACT_APP_IP_FID}:${process.env.REACT_APP_PORT_FID}/pdvs/updatePdv/${values.id_pdv}`, values, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .then(res => {
                // console.log(res);
                window.location.reload(false);
            }).catch(err => console.log(err))
        // }
    }

    
    const close = () => {
        let divTooltip = document.getElementById('popup-2');
        divTooltip.style.display = "none"
    }

    if( !isVisible ) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 backdrop-blur-sm p-4" id="wrapper" onClick={handleClose}>
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[85vh] overflow-y-auto">
                <div className="flex items-center justify-between border-b border-slate-200 px-6 py-4">
                    <h2 className="text-lg font-semibold text-slate-800">Modifier le point de vente</h2>
                    <button type="button" className="text-slate-400 hover:text-slate-600 text-xl leading-none" onClick={() => onClose()}>&times;</button>
                </div>
                <form className="px-6 py-5" onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <label htmlFor="nom" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">Nom</label>
                        <input type="text" name="nom" id="nom" className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30"   onChange={e => setValues({...values, nom: e.target.value})} value={values.nom} />
                    </div>
                    <div className="mb-4">
                        <label htmlFor="adresse" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">Adresse</label>
                        <input type="text" name="adresse" id="adresse" className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30"   onChange={e => setValues({...values, adresse: e.target.value})} value={values.adresse} />
                    </div>
                    <div className="mb-4">
                        <label htmlFor="email" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">Email</label>
                        <input type="text" name="email" id="email" className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30"   onChange={e => setValues({...values, email: e.target.value})} value={values.email} />
                    </div>

                    <div className='flex justify-between'>
                        <Popup trigger=
                            {<button type="button" className="rounded-lg bg-red-600 px-4 py-2 text-sm font-medium text-white hover:bg-red-700" > Supprimer </button>}
                            position="right center">
                            <div className="text-sm text-slate-700">Est-ce votre dernier mot?</div>
                            <div className="mt-2 flex justify-between gap-2">
                                <button type="button" className="rounded-lg bg-red-600 px-4 py-2 text-sm font-medium text-white hover:bg-red-700" onClick={deleteClient}> Accepter </button>
                                <button type="button" className="flex h-9 items-center gap-2 rounded-lg border border-slate-200 bg-white px-4 text-sm font-medium text-slate-700 shadow-sm hover:bg-slate-50" onClick={close}> Annuler </button>
                            </div>
                        </Popup>
                        <button type="submit" className="rounded-lg bg-indigo-500 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-600">Enregistrer</button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default ModalAltaFidModifyPdv;